import React, { useEffect, useState, useContext } from 'react'
import { styled } from '@mui/material/styles'
import Layout from '@/product/components/templates/Layout'
import ListingTableView from '@/product/components/organisms/Product/TableView'
import { Button, IconButton } from '@mui/material'
import ReportContext from '@/product/context/report/reportContext'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import PropTypes from 'prop-types'
import Tab from '@mui/material/Tab'
import AuctionContext from '@/product/context/auction/auctionContext'
import { mapData } from '@/product/common/components'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import AlertContext from '@/product/context/alert/alertContext'
import {
    handleRedirectInternal,
    dateTimeFormatFunction,
} from '@/product/common/components'
import ImageEdit from '@/product/components/organisms/ImageEdit/index'
// import FieldHeader from './FieldHeader'
import CustomSearch from '../../../components/molecules/CustomSearch'
import CustomTable from '../../../components/molecules/CustomTable'
import SettingContext from '@/product/context/setting/settingContext'
import ScheduledPickupContext from '@/product/context/scheduledPickup/scheduledPickupContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import AllOrders from './allOrders'
import '../Schedule.css'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import CustomCommonContext from '@/custom/context/common/commonContext'
import AuthContext from '@/product/context/auth/authContext'

const PREFIX = 'ERP'

const classes = {
    root: `${PREFIX}-root`,
}

const StyledLayout = styled(Layout)(({ theme }) => ({
    [`& .${classes.root}`]: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}))
function calculateRemainingTime2(startDate, endDate) {
    // Convert date strings to Date objects
    const startDateObj = new Date(startDate)
    const endDateObj = new Date(endDate)

    // Calculate the time difference in milliseconds
    const timeDiff = endDateObj.getTime() - startDateObj.getTime()

    // Convert time difference to days, hours, and minutes
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
    const hours = Math.floor(
        (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))

    // Determine the appropriate time unit to display
    if (days > 0) {
        return `${days} day${days > 1 ? 's' : ''}`.replace(/-/g, '')
    } else if (hours > 0) {
        return `${hours} hour${hours > 1 ? 's' : ''}`.replace(/-/g, '')
    } else {
        return `${minutes} minute${minutes > 1 ? 's' : ''}`.replace(/-/g, '')
    }
}

// Example usage

function TabPanel(props) {
    // const { children, value, index, ...other } = props
    // if (value == 0) {
    //     console.log(
    //         '9999999999999',
    //         value,
    //         index,
    //         value == index,
    //         value !== index
    //     )
    // }
    // return (
    //     <div
    //         role="tabpanel"
    //         hidden={value == 0 ? value !== index : false}
    //         id={`simple-tabpanel-${index}`}
    //         aria-labelledby={`simple-tab-${index}`}
    //         {...other}
    //     >
    //         {value == 0 ? value == index : true && <div>{children}</div>}
    //     </div>
    // )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}
function calculateRemainingTime(targetDate) {
    // Convert target date string to Date object
    const endDate = new Date(targetDate)

    // Get the current date
    const now = new Date()

    // Calculate the time difference in milliseconds
    const timeDiff = endDate.getTime() - now.getTime()

    // Convert time difference to days, hours, and minutes
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
    const hours = Math.floor(
        (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))

    // Determine the appropriate time unit to display
    if (days > 0) {
        return `${days} day${days > 1 ? 's' : ''}`.replace(/-/g, '')
    } else if (hours > 0) {
        return `${hours} hour${hours > 1 ? 's' : ''}`.replace(/-/g, '')
    } else {
        return `${minutes} minute${minutes > 1 ? 's' : ''}`.replace(/-/g, '')
    }
}

// Example usage

const Orders = (props) => {
    const settingcontext = useContext(SettingContext)
    const scheduledPickupContext = useContext(ScheduledPickupContext)
    const dynamicContext = useContext(DynamicContext)
    const alertContext = useContext(AlertContext)
    const customCommonContext = useContext(CustomCommonContext)
    const [noShowStatus, setNoShowStatus] = useState(false)
    const { allLocations } = customCommonContext
    const { erp_tablefields, project_dynamicfields, propertyColumnReOrder } =
        dynamicContext
    const { setAlert } = alertContext
    const [tableBody, setTableBody] = useState([])
    const [value, setValue] = useState(0)
    const [tableValue, setTableValue] = useState([])
    const [changeStatus, setChangeStatus] = useState(false)
    const [pickupList, setPickupList] = useState(false)
    const [singleInvoice, setSingleInvoice] = useState(false)
    const history = useHistory()
    const [custom, setCustom] = useState({})
    const [mainID, setMainID] = useState(0)
    const [scheduleData, setScheduleData] = useState([])
    const [selected, setSelected] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [pickupLoading, setPickupLoading] = useState(false)
    const {
        getAllScheduledPickup,
        changeProductStatus,
        all_scheduled_pickup,
        schedule_data,
        getSchedulePickupTiming,
        responseStatus,
        clearResponse,
        schedulePickupAction,
    } = scheduledPickupContext
    const authContext = useContext(AuthContext)
    const { user } = authContext
    const toggleImageEditFullScreenPopup = (popup, id) => {}

    const [aucId, setAucId] = useState('')
    const [lotStatus, setLotStatus] = useState('draft')
    const toggleBulkImagePopup = (popup) => {
        setBulkImagePopup({ popup })
    }

    const onClickEdit = (id, secondaryID, type) => {
        setMainID(id)
        setChangeStatus(true)
    }

    useEffect(() => {
        if (schedule_data && schedule_data.records.length) {
            setScheduleData(schedule_data.records)
            setPickupLoading(false)
        } else {
            setScheduleData([])
            setPickupLoading(false)
        }
    }, [schedule_data])

    const submitFunction = (id) => {
        let data = { id: mainID }
        data.schedule_status =
            value === 1
                ? 'waiting'
                : value === 2
                ? 'serving'
                : value === 3
                ? 'completed'
                : 'completed'
        data[
            value === 1
                ? 'waiting_date'
                : value === 2
                ? 'serving_date'
                : value === 3
                ? 'completed_date'
                : 'completed_date'
        ] = moment(
            dateTimeFormatFunction(new Date()),
            'MM-DD-YYYY h:mm a'
        ).format()

        schedulePickupAction(data)
    }

    const formik = useFormik({
        initialValues: {
            limit: 20,
            page: 1,
            orderby: '',
            order: '',
            groupby: 'spu.invoice_id',
            filters: {
                status: {
                    type: 'in',
                    value: '',
                    field: 'schedule_status',
                },
                name: {
                    type: 'like',
                    value: '',
                    field: 'name',
                },
            },
        },
        enableReinitialize: false,
        onSubmit: (values) => {
            setIsLoading(true)
            getAllScheduledPickup(values, 'main')
        },
    })

    const formikPickup = useFormik({
        initialValues: {
            limit: 12,
            page: 1,
            orderby: 'p.date_closed,asc',
            order: '',
            scheduled: 1,
            admin: true,
            filters: {
                invoice_id: {
                    value: [],
                    type: 'array',
                    field: 'spu.id',
                },
            },
            action: 'won',
        },
        enableReinitialize: false,
        onSubmit: (values) => {
            setIsLoading(true)
            getSchedulePickupTiming(values, 'getData')
            setPickupLoading(true)
            setPickupList(!pickupList)
        },
    })

    useEffect(() => {
        if (value > 0) formik.handleSubmit()
    }, [value])

    useEffect(() => {
        if (all_scheduled_pickup && all_scheduled_pickup.from == 'main') {
            if (
                all_scheduled_pickup.records &&
                all_scheduled_pickup.records.length
            ) {
                if (value == 1) {
                    all_scheduled_pickup.records.map((ele) => {
                        ele.timeWaited = calculateRemainingTime(
                            ele.booking_start_date
                        )
                    })
                } else if (value == 2) {
                    all_scheduled_pickup.records.map((ele) => {
                        ele.timeWaited = calculateRemainingTime(
                            ele.waiting_date
                        )
                    })
                } else if (value == 3) {
                    all_scheduled_pickup.records.map((ele) => {
                        ele.timeWaited = calculateRemainingTime(
                            ele.serving_date
                        )
                    })
                } else if (value == 4) {
                    all_scheduled_pickup.records.map((ele) => {
                        ele.timeWaited = calculateRemainingTime2(
                            ele.serving_date,
                            ele.completed_date
                        )
                    })
                }
            }

            setTableBody(
                all_scheduled_pickup.records.length
                    ? all_scheduled_pickup.records
                    : []
            )
            setIsLoading(false)
        }
    }, [all_scheduled_pickup])

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.status === 'success') {
                if (responseStatus.from == 'scheduledPickupAction') {
                    setAlert('Successfully Updated', responseStatus.status)
                    setMainID(0)
                    formik.handleSubmit()
                    setChangeStatus(false)
                    formikNotesSelection.handleReset()
                    setNoShowStatus(false)
                    setSelected([])
                }
            } else {
                setAlert(responseStatus.message, responseStatus.status)
            }
            clearResponse()
        }
    }, [responseStatus])

    const onClickInvoiceEdit = (id, secondaryID, type) => {
        handleRedirectInternal(history, `invoice/view/${id}/${secondaryID}`)
    }
    const onClickUserEdit = (id, secondaryID, type) => {
        if (user?.emp_type === 'super_admin' || user?.emp_type === 'admin') {
            handleRedirectInternal(history, `user/edit/${id}`)
        }
    }

    const formikNotesSelection = useFormik({
        initialValues: {
            notes: '',
            action: 'no_show',
            schedule_status: 'no_show',
            booking_start_date: null,
            booking_end_date: null,
            inventory_location: '',
            id: [],
        },
        validationSchema: Yup.object({
            notes: Yup.string().required('Required'),
            inventory_location: Yup.string().required('Required'),
        }),
        onSubmit: (values) => {
            schedulePickupAction(values)
        },
    })

    const changeNoshowStatus = () => {
        setNoShowStatus(false)
        formikNotesSelection.handleReset()
    }

    const invoiceNotes = [
        {
            label: 'Notes',
            name: 'notes',
            type: 'textarea',
            placeholder: 'Enter your notes',
            formik: formikNotesSelection,
        },
        {
            label: 'Inventory Location',
            name: 'inventory_location',
            type: 'text',
            placeholder: 'Enter Inventory Location',
            formik: formikNotesSelection,
        },
    ]

    const scheduleValues = [
        {
            field: 'buynow_common_invoice',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Invoice ID',
        },
        {
            field: 'users_first_name',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Buyer Name',
        },
        {
            field: 'users_email',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Buyer Email',
        },
        {
            field: 'users_phone',
            type: 'phone',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Buyer Phone',
        },
        {
            field: 'project_id',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Lot ID',
        },
        {
            field: 'title',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Title',
        },
        {
            field: 'location',
            type: 'singleSelect',
            valueOptions: allLocations
                .filter((value) => value.active == 1)
                .map((item) => {
                    let valueChanged = {}
                    valueChanged.label = item.name
                    valueChanged.value = item.id?.toString()
                    return valueChanged
                }),
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Location',
        },
        {
            field: 'qty',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Qty',
        },
    ]
    const tableValues = [
        {
            field: 'name',
            clickID: 'user_id',
            onclick: onClickUserEdit,
            type: 'hyperlink',

            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Name',
        },
        {
            field: 'phone',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Phone Number',
        },
        {
            field: 'email',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Email',
        },
        {
            field: 'invoice_id',
            clickID: 'invoice_id',
            onclick: onClickInvoiceEdit,
            type: 'hyperlink',
            secondaryClickID: 'user_id',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Invoice ID',
        },

        // {
        //     field: 'invoice',
        //     type: '',
        //     firstChild: true,
        //     sort: false,
        //     disablePadding: false,
        //     label: 'Booking Time',
        // },
    ]

    if (value !== 6) {
        if (value !== 5) {
            tableValues.push(
                {
                    field: 'booking_start_date',
                    type: 'datetime',
                    firstChild: true,
                    sort: false,
                    disablePadding: false,
                    label: 'Booking Time',
                }
                // {
                // field: 'timeWaited',
                // type: '',
                // firstChild: true,
                // sort: false,
                // disablePadding: false,
                // label: 'Time Waited',
                // }
            )
        }
        if (value !== 4 && value !== 5) {
            tableValues.push({
                name: 'action',
                field: 'action',
                type: 'button',
                clickID: 'id',
                sort: false,
                clickType: 'edit',
                firstChild: false,
                disablePadding: false,
                label: 'Action',
                onclick: onClickEdit,
                buttonType: 'edit',
                tableShow: 1,
            })
        }
    }
    if (value === 4) {
        tableValues.push({
            field: 'completed_date',
            type: 'datetime',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Completed Time',
        })
    }
    const handleChange = (event, newValue) => {
        if (newValue === 0) {
            setValue(newValue)
        } else if (newValue === 1) {
            formik.values.filters.status.value = 'booking'
            setValue(newValue)
        } else if (newValue === 2) {
            formik.values.filters.status.value = 'waiting'
            setValue(newValue)
        } else if (newValue === 3) {
            formik.values.filters.status.value = 'serving'
            setValue(newValue)
        } else if (newValue === 4) {
            formik.values.filters.status.value = 'completed'
            setValue(newValue)
        } else if (newValue === 5) {
            formik.values.filters.status.value = 'no_show'
            setValue(newValue)
        } else if (newValue === 6) {
            formik.values.filters.status.value = 'relist_invoice'
            setValue(newValue)
        }
    }
    const additionalFilterCallBack = (data) => {
        setLotStatus(data.lots)
        setAucId(data.auctions)
    }
    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        }
    }
    const searchInfo = [
        {
            label: 'Name',
            placeholder: 'Search Customer Name',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'name',
            formik: formik,
            filter: true,
        },
    ]
    const changeChangeStatus = () => {
        setChangeStatus(false)
    }
    const handlePickupList = (data) => {
        formikPickup.values.filters.invoice_id.value = data
        formikPickup.handleSubmit()
    }
    const handleSingleInvoice = () => {
        setSingleInvoice(!singleInvoice)
    }
    const onSelectMultiProducts = (data, action) => {
        let datas
        if (action != 'show') {
            datas = { id: data }
            datas.schedule_status =
                action === 'waiting'
                    ? 'waiting'
                    : action === 'serve'
                    ? 'serving'
                    : action === 'completed'
                    ? 'completed'
                    : action === 'deleted'
                    ? 'deleted'
                    : action === 'no_show'
                    ? 'no_show'
                    : 'completed'
            datas[
                action === 'waiting'
                    ? 'waiting_date'
                    : action === 'serve'
                    ? 'serving_date'
                    : action === 'completed'
                    ? 'completed_date'
                    : action === 'no_show'
                    ? 'no_show'
                    : 'completed_date'
            ] = moment(
                dateTimeFormatFunction(new Date()),
                'MM-DD-YYYY h:mm a'
            ).format()
            if (action == 'no_show') {
                formikNotesSelection.values.id = data
                formikNotesSelection.values.schedule_status = 'no_show'
                formikNotesSelection.values.action = 'no_show'
                setNoShowStatus(true)
            } else if (action == 'relist_invoice') {
                let dataRelistInvoice = {
                    id: data,
                    schedule_status: 'relist_invoice',
                    action: 'relist_invoice',
                }

                schedulePickupAction(dataRelistInvoice)
            } else {
                schedulePickupAction(datas)
            }
        }
    }
    let tempTableActions = []
    if (value !== 6) {
        if (value !== 3) {
            tempTableActions.push({
                label: 'Move to Serving',
                icon: <span className="material-icons">low_priority</span>,
                onclick: onSelectMultiProducts,
                type: 'serve',
                action: 'draft',
            })
        }
        if (value !== 4) {
            tempTableActions.push({
                label: 'Move to Completed',
                icon: <span className="material-icons">add_task</span>,
                onclick: onSelectMultiProducts,
                type: 'completed',
                action: 'draft',
            })
        }

        // tempTableActions.push({
        //     label: 'Move to Deleted',
        //     icon: <span className="material-icons">delete</span>,
        //     onclick: onSelectMultiProducts,
        //     type: 'deleted',
        //     action: 'draft,open,unsold',
        // })
        if (value !== 5) {
            tempTableActions.push({
                label: 'Move to No Show',
                icon: <span className="material-icons">visibility_off</span>,
                onclick: onSelectMultiProducts,
                type: 'no_show',
                action: 'draft,open,unsold',
            })
        }
    }

    if (value === 5) {
        tempTableActions.push({
            label: 'Move to Relist',
            icon: <span className="material-icons">restart_alt</span>,
            onclick: onSelectMultiProducts,
            type: 'relist_invoice',
            action: 'relist_invoice',
        })
    }

    const selectedRowCount = (data) => {
        setSelected(data)
    }

    const closeFunction = () => {
        setPickupList(!pickupList)
        setSelected([])
        getAllScheduledPickup(formik.values, 'main')
    }

    return (
        <>
            <div className="dashboard listing maillisting erpMisc sheduleSubTabsContainer">
                {/* <FieldHeader /> */}
                <div className="OrderSubTabs">
                    <AppBar position="static" className="ordersTab">
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="ERP Tabs"
                        >
                            <Tab label="All" {...a11yProps(0)} />
                            <Tab label="Booking" {...a11yProps(1)} />
                            <Tab label="Waitlist" {...a11yProps(2)} />
                            <Tab label="Serving" {...a11yProps(3)} />
                            <Tab label="Completed" {...a11yProps(4)} />
                            <Tab label="No Show" {...a11yProps(5)} />
                            <Tab label="Relisted" {...a11yProps(6)} />
                        </Tabs>
                    </AppBar>
                    <div className="searchItems">
                        <CustomSearch searchInfo={searchInfo} formik={formik} />
                    </div>
                </div>
                {value === 0 ? (
                    <AllOrders />
                ) : (
                    <div className="tableViewSec">
                        {/* <CustomSearch searchInfo={searchInfo} formik={formik} /> */}
                        <CustomTable
                            formik={formik.values}
                            tableBody={tableBody}
                            tableValues={tableValues}
                            tableActions={tempTableActions}
                            allData={all_scheduled_pickup}
                            isLoading={isLoading}
                            loadingTemplate={'table'}
                            selectedRowCount={selectedRowCount}
                            changeTableFunction={getAllScheduledPickup}
                            hideCompactView={props.hideCompactView}
                        />
                    </div>
                )}
                {selected.length ? (
                    <div className="stickyBottom">
                        <Button
                            className="stickyBtns"
                            onClick={() =>
                                onSelectMultiProducts(selected, 'serve')
                            }
                        >
                            Serve ({selected.length})
                        </Button>
                        {/* <Button className="stickyBtns" onClick={() => onSelectMultiProducts(selected,'completed')}>No Show ({selected.length} )</Button> */}
                        <Button
                            className="stickyBtns"
                            onClick={() =>
                                onSelectMultiProducts(selected, 'completed')
                            }
                        >
                            Completed ({selected.length} )
                        </Button>
                        {/* <Button className="stickyBtns">Message ({selected.length})</Button> */}
                        <Button
                            className="stickyBtns"
                            onClick={() =>
                                onSelectMultiProducts(selected, 'deleted')
                            }
                        >
                            Delete ({selected.length})
                        </Button>
                        <Button
                            className="stickyBtns"
                            onClick={() =>
                                onSelectMultiProducts(selected, 'no_show')
                            }
                        >
                            No Show ({selected.length})
                        </Button>
                        <Button
                            className="stickyBtns"
                            onClick={() => handlePickupList(selected)}
                        >
                            Create a Pick List ({selected.length})
                        </Button>
                    </div>
                ) : null}

                <CustomDialog
                    title={'Change Scheduled Pickup status'}
                    open={noShowStatus}
                    function={changeNoshowStatus}
                >
                    <h5>{`Are you sure you want to change the status to no Show ?`}</h5>
                    {mapData(invoiceNotes)}
                    <div className="actionWrapper">
                        <Button
                            id="bidDeposit_cancel"
                            onClick={() => changeNoshowStatus()}
                        >
                            Cancel
                        </Button>

                        <PrimaryButton
                            id="bidDeposit_submit"
                            onClick={() => formikNotesSelection.handleSubmit()}
                            label="Confirm"
                        />
                    </div>
                </CustomDialog>
                <CustomDialog
                    className="singleInvcRoot"
                    open={singleInvoice}
                    function={handleSingleInvoice}
                    maxWidth="xl"
                >
                    <div className="cusHeader d-flex align-items-center justify-content-between flex-wrap">
                        <div className="cusSide">
                            Invoice #10321 <span className="ml-3">3 items</span>
                        </div>
                        <div className="cusBody">
                            <span className="mr-3 inStatus">
                                <i className="material-icons mr-1">
                                    fiber_manual_record
                                </i>
                                Status
                            </span>
                            <span className="mr-3 inBdge">
                                Customer waiting
                            </span>
                            <IconButton onClick={handleSingleInvoice}>
                                <span className="material-icons-outlined me-2">
                                    close
                                </span>
                            </IconButton>
                        </div>
                    </div>
                    <div className="invBdyElementRoot">
                        <div className="invChildLftElement">
                            <div className="cusDetls mb-4">
                                <label>Colleen Quadros</label>
                                <div className="cusDetlsLst">
                                    <span>Colleen Quadros</span>
                                    <span>
                                        <i className="material-icons-outlined mr-2">
                                            mail
                                        </i>
                                        quadros@gmail.com
                                    </span>
                                    <span>
                                        <i className="material-icons-outlined mr-2">
                                            call
                                        </i>
                                        (547)-756-1021
                                    </span>
                                </div>
                            </div>
                            <div className="slotDetls mb-4">
                                <div className="slotDetlsLst">
                                    <label>Order created</label>
                                    <span>11/01/2023 at 11:23 AM</span>
                                </div>
                                <div className="slotDetlsLst">
                                    <label>Pick up slot</label>
                                    <span>11/05/2023 at 11:15 - 11:30 AM</span>
                                </div>
                            </div>
                            <div className="invoiceCard">
                                <div className="table-responsive">
                                    <table className="w-100">
                                        <thead>
                                            <tr>
                                                <th>Items</th>
                                                <th>Qty</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Dyson vaccuum cleaner</td>
                                                <td>2</td>
                                                <td>$150.00</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td></td>
                                                <td>Before tax</td>
                                                <td>$400.00</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td>Sales tax</td>
                                                <td>$25.00</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td>Total</td>
                                                <td>$425.00</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="invChildRgtElement">
                            <div className="invBtnGrp d-flex align-items-center mb-4">
                                <SecondaryButton btnSize="mr-3 small">
                                    View invoice
                                </SecondaryButton>
                                <SecondaryButton btnSize="mr-3 small">
                                    <i className="material-icons-outlined">
                                        chat_bubble_outlined
                                    </i>
                                    Message customer
                                </SecondaryButton>
                            </div>
                            <div className="invNotes">
                                <div className="ntsRootElement">
                                    <div className="ntsHdr">
                                        <div className="tit">Notes</div>
                                        <Button>Edit</Button>
                                    </div>
                                    <p>
                                        Customer has placed a request to
                                        individually box the 3 items.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </CustomDialog>

                <CustomDialog
                    title={'Pickup List'}
                    open={pickupList}
                    closeBtn={true}
                    function={closeFunction}
                    maxWidth="xl"
                >
                    <CustomTable
                        formik={formikPickup.values}
                        tableBody={scheduleData}
                        tableValues={scheduleValues}
                        tableActions={[]}
                        allData={schedule_data}
                        isLoading={pickupLoading}
                        loadingTemplate={'table'}
                    />
                    <div className="d-flex align-items-center justify-content-end mt-3">
                        {/* <PrimaryButton btnSize="mr-2">
                            <span className="material-icons mr-2">
                                download
                            </span>
                            Download
                        </PrimaryButton> */}
                        <SecondaryButton onClick={() => window.print()}>
                            <span className="material-icons mr-2">print</span>
                            Print
                        </SecondaryButton>
                    </div>
                </CustomDialog>

                <CustomDialog
                    title={'Change Scheduled Pickup status'}
                    open={changeStatus}
                    function={changeChangeStatus}
                >
                    <h5>{`Are you sure you want to change the status from ${
                        value === 1
                            ? 'Booking'
                            : value === 2
                            ? 'Waitlist'
                            : value === 3
                            ? 'Serving'
                            : ''
                    } to ${
                        value === 1
                            ? 'Waitlist'
                            : value === 2
                            ? 'Serving'
                            : value === 3
                            ? 'Completed'
                            : ''
                    } `}</h5>
                    <div className="actionWrapper">
                        <Button
                            id="bidDeposit_cancel"
                            onClick={() => changeChangeStatus()}
                        >
                            Cancel
                        </Button>

                        <PrimaryButton
                            id="bidDeposit_submit"
                            onClick={() => submitFunction()}
                            label="Confirm"
                        />
                    </div>
                </CustomDialog>
            </div>
        </>
    )
}

export default Orders
